export default __webpack_public_path__ + "static/media/bg2.bf49698f.jpg";